import { createApi } from '@reduxjs/toolkit/query/react';
import { REPORT_CONFIGS_API } from 'services/constants';
import { rawBaseQuery } from 'services/shared';
import { PostReportConfigBody, ReportConfigResponse } from 'services/types';

export const reportConfigsApi = createApi({
  reducerPath: REPORT_CONFIGS_API,
  baseQuery: rawBaseQuery,
  endpoints: (builder) => ({
    getReports: builder.query<ReportConfigResponse[], void>({
      query: () => encodeURI(`/reportConfigurations`),
    }),

    getSingleReport: builder.query<ReportConfigResponse[], string>({
      query: (report_name) => encodeURI(`/reportConfigurations/${report_name}`),
    }),

    deleteReport: builder.query<ReportConfigResponse[], string>({
      query: (report_name) => encodeURI(`/reportConfigurations/${report_name}`),
    }),

    postReport: builder.mutation<ReportConfigResponse, PostReportConfigBody>({
      query: (report) => ({
        url: encodeURI(`/reportConfigurations`),
        method: 'POST',
        body: report,
      }),
    }),
  }),
});

export const {
  useGetReportsQuery,
  useLazyGetReportsQuery,
  useGetSingleReportQuery,
  usePostReportMutation,
} = reportConfigsApi;
